import { parseLocaleFromPathname } from "./localeUrl";
import { isTripMasterSurface } from "../surfaces/tripMaster/tripMasterEnv";

/**
 * Public TripMaster / vacation-packages pages that must open from the top
 * on client-side navigation. Agent dashboard paths are excluded.
 */
export function isPublicPageScrollResetPath(pathname) {
  const { pathnameWithoutLocale } = parseLocaleFromPathname(pathname);
  const path = pathnameWithoutLocale || "/";

  if (path === "/vacation-packages" || path.startsWith("/vacation-packages/")) return true;
  if (path === "/vacation_packages" || path.startsWith("/vacation_packages/")) return true;
  if (path === "/search" || path === "/packages" || path === "/hotels" || path === "/flights") {
    return true;
  }
  if (path.startsWith("/package/") || path.startsWith("/destination/")) return true;
  if (path === "/booking" || path.startsWith("/booking/")) return true;
  if (
    path.startsWith("/payment/success/") ||
    path.startsWith("/payment/fail/") ||
    path.startsWith("/payment/cancel/")
  ) {
    return true;
  }
  if (path === "/" && isTripMasterSurface()) return true;
  return false;
}

/** Pathname + booking/results stage, not every query param (siteId, dates). */
export function getPublicPageScrollResetKey(location = {}) {
  const params = new URLSearchParams(String(location.search || "").replace(/^\?/, ""));
  return [
    String(location.pathname || "/"),
    params.get("stage") || "",
    params.get("hotelId") || "",
    params.get("flightId") || "",
  ].join("|");
}
